export function getHookEventElement(ref) {
    return ref && 'current' in ref ? ref.current : ref;
}
//# sourceMappingURL=getHookEventElement.js.map